/* eslint-disable react/jsx-newline, no-extra-parens, max-statements, react/no-multi-comp, react/no-unstable-nested-components */
import { Col, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Loader from "../../components/Loader";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";

import CourseBody from "./components/CourseBody";
import CourseHeader from "./components/CourseHeader";
import CourseSidebar from "./components/CourseSidebar";
import LWCErrorBoundary from "../../components/LwcErrorBoundary";
import { getCourse } from "../../services/wp.course.query";

const CourseSingle = () => {

	const params = useParams();
	const {
		data: course,
		isLoading
	} = getCourse(useQuery, params.courseId);

	if (isLoading) {
		return <Loader />;
	}

	return (
		<>
			<Helmet>
				<title>{ course.title } - Life With Cancer Events</title>
				{course.subTitle ? <meta content={course.subTitle} name="description" /> : null}
			</Helmet>
			<article className="course-single">
				<Row>
					<Col className="px-0">
						<CourseHeader course={course} />

						<LWCErrorBoundary>
							<CourseBody
								course={course}
								courseList={course ? course.series ? course.series.courses : [course] : []}
							/>
						</LWCErrorBoundary>
					</Col>

					<Col className="bg-white" lg={3} md={3} sm={12}>
						<LWCErrorBoundary>
							<CourseSidebar course={course} />
						</LWCErrorBoundary>
					</Col>
				</Row>
			</article>
		</>
	);
};

export default CourseSingle;
